import React, {FC} from "react"

import {CompanyNewsTile} from "@irati/types"

import {StyledFlex, StyledDiv, StyledWrapper} from "../Template/styled"
import Icon from "../Template/Icon"
import TemplateTitle from "../Template/Title"
import TemplateFindOutMore from "../Template/FindOutMore"
import Message from "./Message"
import {StyledContentSvgCard, StyledContentWrapper, StyledImageTile} from "./styled"

interface Props {
  companyNewsTile: CompanyNewsTile
}

const TemplateTile: FC<Props> = ({companyNewsTile}) => {
  const isMidSizedContent = companyNewsTile.config.columnWidth < 4
  const {backgroundColor, message, templateIcon, templateText} = companyNewsTile.config

  return (
    <StyledImageTile>
      <StyledContentWrapper>
        <StyledWrapper>
          <StyledContentSvgCard color={backgroundColor} isMisMidSizedContent={isMidSizedContent}>
            <StyledFlex>
              <StyledDiv>
                <Icon icon={templateIcon} />
                {templateText && <TemplateTitle templateText={templateText} />}
                <TemplateFindOutMore />
              </StyledDiv>
            </StyledFlex>
          </StyledContentSvgCard>
        </StyledWrapper>
      </StyledContentWrapper>
      <Message message={message} />
    </StyledImageTile>
  )
}

export default TemplateTile
